import classNames from 'classnames'
import CompenstaionHelper from 'legacy/lut/classes/helpers/partner360/CompenstaionHelper'
import { JSX, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { IForm } from 'core-components/classes/models/IForm'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './SimpleField.module.scss'

export interface ISimpleFieldProps {
  className?: string
  item: IForm
  field: string
  copy?: boolean
  label?: string
  value?: string | number | null
  translate?: boolean
  size?: 'normal' | 'lg' | 'sm' | 'max'
  moneyFormat?: boolean
  moneyIntegerFormat?: boolean
  allowZero?: boolean
  defaultStyle?: boolean
  labelContent?: () => JSX.Element
  valueContent?: () => JSX.Element
  multiline?: boolean
}

const defaultTooltipMessage = 'Click to copy'

export const SimpleField = ({
  className,
  item,
  field,
  label,
  value,
  translate,
  size = 'normal',
  moneyFormat,
  moneyIntegerFormat,
  allowZero,
  defaultStyle,
  copy,
  labelContent,
  valueContent,
  multiline,
}: ISimpleFieldProps) => {
  const [tooltipMessage, setTooltipMessage] = useState(defaultTooltipMessage)
  const val =
    value || (!!allowZero && value !== null && Number(value || 0) === 0)
      ? value
      : item[field] || (!!allowZero && item[field] !== null && Number(item[field] || 0) === 0)
        ? item[field]
        : '-'

  const format = moneyFormat
    ? CompenstaionHelper.formatMoney
    : moneyIntegerFormat
      ? CompenstaionHelper.formatMoneyInteger
      : undefined

  const handleCopy = () => {
    if (val === '-') {
      return
    }

    navigator.clipboard.writeText(val)
    setTooltipMessage('Copied')
  }

  const showCopyButton = copy && val !== '-'

  return (
    <p className={classNames(styles.root, className || '')}>
      {(label || labelContent) && (
        <span className={classNames(styles.label, size !== 'normal' && styles[`label__${size}`])}>
          {label && translate ? <Translation text={label} span actionsInside /> : label}
          {label && ':'}
          {labelContent && labelContent()}
        </span>
      )}
      {valueContent ? (
        valueContent()
      ) : (
        <span
          className={classNames(
            styles.value,
            { [styles.max]: size === 'max' },
            !defaultStyle && (moneyFormat || moneyIntegerFormat) && styles.value__money,
            { [styles.multiline]: !!multiline }
          )}
        >
          {format && val !== '-' ? format(val) : val}
        </span>
      )}
      {showCopyButton && (
        <span
          className={classNames(styles.copyValue)}
          onMouseLeave={() => setTooltipMessage(defaultTooltipMessage)}
        >
          <Tooltip tipContent={() => <>{tooltipMessage}</>}>
            <i
              className={classNames('kbase kbase-copy', styles.clickableIcon)}
              onClick={handleCopy}
            />
          </Tooltip>
        </span>
      )}
    </p>
  )
}
